import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './TabbedViewWithDateSelect.module.css';
import { DISPLAY_MESSAGES } from '../../constants';
import TabWithCount from '../TabWithCount/TabWithCount';

const Panel = ({ children, value, index }) => {
  if (index !== value) return <div style={{ display: 'none' }} />;
  return <>{children}</>;
};

const TabbedWorkspace = ({ tabs, isAggregate, reloadData }) => {
  const [tabVal, setTabVal] = useState(0);
  const [hasActiveEdits, setHasActiveEdits] = useState(false);

  const handleTabChange = (value, isInEdit) => {
    let shouldChangeTab = true;
    if (isInEdit) {
      shouldChangeTab = window.confirm(DISPLAY_MESSAGES.NAVIGATION_WARNING);
    }
    if (shouldChangeTab) {
      setTabVal(value);
      if (reloadData) reloadData();
    }
  };

  useEffect(() => {
    setHasActiveEdits(false);
  }, [tabVal]);

  return (
    <div className={styles.workspace}>
      <div className={styles.tabBar}>
        {tabs.map((tab, index) => (
          <TabWithCount
            value={tabVal}
            action={tab.label}
            count={tab.count}
            title={tab.title}
            countColor={tab.countColor}
            backgroundColor={tab.backgroundColor}
            handleClick={() => handleTabChange(index, hasActiveEdits)}
            isSelected={index === tabVal}
          />
        ))}
      </div>
      {tabs.map((tab, index) => (
        <Panel value={tabVal} index={index}>
          <tab.component
            {...tab.props}
            hasActiveEdits={hasActiveEdits}
            setHasActiveEdits={setHasActiveEdits}
          />
        </Panel>
      ))}
    </div>
  );
};

const TabbedViewWithDateSelect = props => {
  const { tabs, pageTitle, reloadData } = props;

  return (
    <>
      <div className={styles.container}>
        <div className={styles.body}>
          <TabbedWorkspace tabs={tabs} reloadData={reloadData} />
        </div>
      </div>
    </>
  );
};

TabbedViewWithDateSelect.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      component: PropTypes.elementType.isRequired,
      props: PropTypes.object,
    }),
  ).isRequired,
  pageTitle: PropTypes.string.isRequired,
  reloadData: PropTypes.func,
};

export default TabbedViewWithDateSelect;
